import { jsx } from "react/jsx-runtime";
import { useFieldActions } from "../../../../contexts/field-actions-context.js";
import { FieldPropsContext } from "../../../../contexts/field-props-context.js";
import { useForm } from "../../../../contexts/form-context.js";
import { useSubmitButton } from "../../../../fields/submit-button/submit-button/use-submit-button.js";
import { useExternalData } from "../../contexts/external-data-context.js";
import { useFormFields } from "../../contexts/form-fields-context.js";
const SubmitButtonField = ({
  field,
  FieldLayout
}) => {
  const { submitText, nextText, previousText, text } = field.properties;
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const { actions } = useFieldActions();
  const {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    hasSteps
  } = useSubmitButton({
    form,
    id: field.id
  });
  const submitButtonText = submitText || text || "";
  const previousButtonText = previousText || "";
  const nextButtonText = nextText || "";
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  const fieldProps = {
    ...field.properties,
    id: field.id,
    externalData,
    fieldType: field.fieldType,
    FieldLayout,
    hasSteps,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    submitText: submitButtonText,
    previousText: previousButtonText,
    nextText: nextButtonText,
    onSubmitClick: handleSubmitClick,
    onPreviousClick: () => actions?.setPreviousStep(),
    onNextClick: () => actions?.setNextStep()
  };
  return /* @__PURE__ */ jsx(FieldPropsContext.Provider, { value: { v2: fieldProps }, children: /* @__PURE__ */ jsx(FieldComponent, { ...fieldProps }) });
};
export {
  SubmitButtonField
};
//# sourceMappingURL=submit-button-field.js.map
